module.exports = __webpack_public_path__ + "media/images/top/mainimage02-7a606ecefed08b13cf82f0a68c8b25e9.png";